export default [
  {
    value: "name",
    text: "Project",
    sortable: true,
    width: 200,
  },
  {
    value: "exid",
    text: "Project ID",
    sortable: true,

    width: 40,
  },
  {
    value: "status",
    text: "Status",
    sortable: true,
    width: 120,
    align: "center",
  },

  {
    value: "cameras",
    text: "Cameras",
    sortable: false,

    width: 40,
  },
  {
    value: "cameraStatuses",
    text: "Statuses",
    sortable: false,
    align: "center",
    width: 40,
  },
  {
    value: "lastDetection",
    text: "Last detection",
    sortable: false,
    width: 20,
  },
  {
    value: "relatedAnpr",
    text: "Related Anpr",
    sortable: false,
    width: 20,
  },
  {
    value: "motionDetection",
    text: "Motion detection",
    sortable: false,
    width: 28,
  },
  {
    value: "exNvr",
    text: "ExNVR",
    sortable: false,
    width: 28,
  },
  {
    value: "noLicensePlate",
    text: "No License Plate",
    sortable: false,
    width: 28,
  },
]
